module.exports = __webpack_public_path__ + "static/img/caitaxihuan.baafba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/caitaxihuan.png
// module id = 1213
// module chunks = 0